<template>
    <MapHeader />
   <div id="map"></div>
   <div id="navigation" :class="{active: (mobileMenuActive)}">
       <div class="navigation-header">

           <div @click="toggleMobileMenu" class="toggle-mobile-nav" ></div>

           <div v-if="!activeLayer.id" class="campus-btn noselect" @click="switchCampusSelectionActive">
               <template v-if="!campusSelectionActive">
                   {{campusBtnText}}
                   <div class="campus-btn__caret--down"></div>
               </template>
               <template v-if="campusSelectionActive">
                   Select A Campus
                   <div class="campus-btn__caret--up"></div>
               </template>
           </div>

           <div v-if="activeLayer.id" class="layer-btn noselect">
               <div class="layer-btn__arrow" @click="displayNavHomeView()"></div>
               {{ activeLayer.title }}
           </div>
       </div>
       <div class="navigation-content">

           <!-- CAMPUS SELECTION OPTIONS -->
           <div v-if="campusSelectionActive" class="navigation-content__campus-options">
               <div class="campus_category" @click="adjustCamPos('clinton-crossings')">Clinton Crossings</div>
               <div class="campus_category" @click="adjustCamPos('eastman')">Eastman Campus</div>
               <div class="campus_category" @click="adjustCamPos('highland-hospital')">Highland Hospital</div>
               <div class="campus_category" @click="adjustCamPos('medical-center')">Medical Center</div>
               <div class="campus_category" @click="adjustCamPos('middle-campus')">Middle Campus</div>
               <div class="campus_category" @click="adjustCamPos('mt-hope')">Mt. Hope Campus</div>
               <div class="campus_category" @click="adjustCamPos('river-campus')">River Campus</div>
               <div class="campus_category" @click="adjustCamPos('south-campus')">South Campus</div>
           </div>

           <!-- BUILDING / PARKING TOGGLE VIEW -->
           <div v-if="buildingParkingButtons" class="navigation-content__options">
               <div @click="activateCampusOption('parkingCategory')" 
                   :class="{active: (campusOption === 'parkingCategory')}"
                   class="navigation-content__options__button navigation-content__options__button--left">
                       <div class="topLevelTextBtnContainer">
                           <div class="topLevelIcon topLevelIcon--buildings"></div>
                           <div class="topLevelText">BUILDINGS</div>
                       </div>
               </div>
               <div @click="activateCampusOption('buildingCategory')" 
                   :class="{active: (campusOption === 'buildingCategory')}"
                   class="navigation-content__options__button navigation-content__options__button--right">
                       <div class="topLevelTextBtnContainer">
                           <div class="topLevelIcon topLevelIcon--parking"></div>
                           <div class="topLevelText">PARKING</div>
                       </div>
               </div>
           </div>

           <!-- BUILDING OPTIONS -->
           <div v-if="buildingOptions">
               <div class="campus_category" @click="activateLayer('academic-center')">
                   <div class="icon icon--hat"></div>
                   Academic Center
               </div>
               <div class="campus_category" @click="activateLayer('administration')">
                   <div class="icon icon--people"></div>
                   Administration
               </div>
               <div class="campus_category" @click="activateLayer('athletic-center')">
                   <div class="icon icon--ball"></div>
                   Athletic Center
               </div>
               <div class="campus_category" @click="activateLayer('dining')">
                   <div class="icon icon--cutlery"></div>
                   Dining
               </div>
               <div class="campus_category" @click="activateLayer('event-space')">
                   <div class="icon icon--drama"></div>
                   Event Space
               </div>
               <div class="campus_category" @click="activateLayer('medical-facility')">
                   <div class="icon icon--hospital"></div>
                   Medical Facility
               </div>
               <div class="campus_category" @click="activateLayer('residence-hall')">
                   <div class="icon icon--house"></div>
                   Residence Hall
               </div>
           </div>

           <!-- PARKING OPTIONS -->
           <div v-if="parkingOptions">
               <div class="campus_category" @click="activateLayer('visitor')">
                   <div class="icon icon--cars"></div>
                   Visitor
               </div>
               <div class="campus_category" @click="activateLayer('reserved')">
                   <div class="icon icon--reserved"></div>
                   Reserved
               </div>
               <div class="campus_category" @click="activateLayer('general')">
                   <div class="icon icon--sq-parking"></div>
                   General
               </div>
           </div>

           <!-- LIST OF LOCATIONS -->
           <div v-if="listOfLocations" >
               <div class="list-of-locations-container">
                   <div v-for="(item, index) in layersDuo[activeLayer.id].data.features" :key="index" >
                       <div class="campus_category-item" @click="pushLocationRoute(item.properties.slug)">{{ item.properties.title }}</div>
                   </div>
               </div>
           </div>

           <!-- LOCATION "POPUP" -->
           <LocationDetails 
               v-if="locationDetails"
               :title="activeLocation.title"
               :imgUrl="activeLocation.img_url"
               :desc="activeLocation.desc"
               :coords="activeLocation.coords"
           />

       </div>
   </div>
</template>

<script>
// @ is an alias to /src
import LocationDetails from '@/components/LocationDetails.vue';
import MapHeader from '@/components/MapHeader.vue';
import mapboxgl from 'mapbox-gl';
import router from '../router';
import { useRoute } from 'vue-router';
mapboxgl.accessToken = 'pk.eyJ1IjoidW5pdmVyc2l0eXJvY2hlc3RlciIsImEiOiJja3A3YTR0dXMwM2NmMnJwYWxtbWN6NHQ5In0.PJ4jtsEZAI89T9S1s7gGFg';

export default {
   title: 'University of Rochester Map',
   name: 'MapMain',
   components: {
       LocationDetails,
       MapHeader
   },
   data: function() {

       return {
           activeMarker: [],

           mobileMenuActive: false,

           activeLocation: {
               title: '',
               desc: '',
               img_url: ''
           }, // attributes will display in sidebar when values are assigned

           campusPositions: {}, // includes lat/long + name of all campuses

           campusSelectionActive: false, // Whether or not campus selection button is active

           campusSelection: '', // campus to "flyto"

           campusBtnText: 'River Campus', // Change this if default campus is not RC

           campusBtnTextSelect: 'Select A Campus', // Button text for when Campus Button is clicked

           campusOption: 'parkingCategory', // Building or parking category

           locData: {}, // This comes from directus

           // All of the keys in layersDuo correspond with the names of the layers sent to MapBox
           // All of the values in layersDuo are geojson objects to be posted to MapBox
           layersDuo: {},

           activeLayer: {
               id: '',
               title: ''
           },
           // This data is particular to the UI, and should line up with the database
           // TODO: move data to Directus
           uiLayers: {
                'academic-center': {
                    title: 'Academic Center'
                },
                'administration': {
                    title: 'Administration'
                },
                'athletic-center': {
                    title: 'Athletic Center'
                },
                'dining': {
                    title: 'Dining'
                },
                'event-space': {
                    title: 'Event Space'
                },
                'medical-facility': {
                    title: 'Medical Facility'
                },
                'residence-hall': {
                    title: 'Residence Hall'
                },
                'visitor': {
                    title: 'Visitor'
                },
                'general': {
                    title: 'General'
                },
                'reserved': {
                    title: 'Reserved'
                }
           },

           // TODO: move data to Directus
           markers: {
               'administration': {
                   url: 'public/pins/building/administration.png'
               },
               'general': {
                   url: 'public/pins/parking/general.png'
               },
               'event-space': {
                   url: 'public/pins/building/event-space.png'
               },
               'residence-hall': {
                   url: 'public/pins/building/residence.png'
               },
               'academic-center': {
                   url: 'public/pins/building/academic-center.png'
               },
               'athletic-center': {
                   url: 'public/pins/building/sports.png'
               },
               'medical-facility': {
                   url: 'public/pins/building/medical.png'
               },
               'dining': {
                   url: 'public/pins/building/dining.png'
               },
               'visitor': {
                   url: 'public/pins/parking/visitor.png'
               },
               'reserved': {
                   url: 'public/pins/parking/reserved.png'
               },
           },
          
       }
   },
   computed: {
       //The follow functions correspond with nav states.
       //Placing the logic here instead of UI unclutters template code.
       listOfLocations() {
           return (this.activeLayer.id && !this.activeLocation.title ? true : false);
       },
       locationDetails() {
           return (this.activeLocation.title ? true : false);
       },
       parkingOptions() {
           return (this.campusOption === 'buildingCategory' && !this.activeLayer.id  && !this.activeLocation.title && !this.campusSelectionActive ? true : false);
       },
       buildingOptions() {
           return (this.campusOption === 'parkingCategory' && !this.activeLayer.id && !this.activeLocation.title && !this.campusSelectionActive ? true : false);
       },
       buildingParkingButtons() {
           return (!this.activeLayer.id && !this.campusSelectionActive && !this.activeLocation.title ? true : false);
       },

       //If there is a "slug" (location path) in URL, then return it
       locationSlug() {
           const route = useRoute();
           if (route.params.slug) {
               return route.params.slug;
           } else {
               return false;
           }
       }
   },
   watch: {
       campusSelectionActive: function(newValue) {
           if (newValue === true && this.mobileMenuActive === false) {
               this.toggleMobileMenu();
           }
       },
       $route(to) {

           // If has a slug property then url corresponds with a location popup
           if (to.params.slug) {
               // Display location attributes directly in navigation
               this.displayLocationDetails(to.params.slug);
               return;
           }
       },
       // Whenever active location coords changes, flyto location
       activeLocation: function() {
           // open up mobile nav menu
           this.mobileMenuActive = true;


           if (this.activeLocation.coords) {
               this.flyTo(this.activeLocation.coords.coordinates);
               // example of coordinates: {0: -77.60650949563711, 1: 43.13600064728628}
           }
       },
       // whenever locData changes, this function will run
       locData: function() {
           if (!this.locData.data) {
               return;
           }

           this.locData.data.forEach((item) => {

               var coords = [];

               if (item.input_lat_long_directly == true) {
                   coords = [item.longitude, item.latitude];
               } else {
                   coords = [item.coords.coordinates[0], item.coords.coordinates[1]];
               }

               var locationCategory;

               if (item.location_type === 'building') {
                   locationCategory = item.building_type;
               } else {
                   locationCategory = item.parking_type;
               }

               // If the location category does not yet exist as a layer category
               if (!this.layersDuo[locationCategory])
               {
                   // create a key with the name of the layer
                   this.layersDuo[locationCategory] = 
                       {
                           'type': 'geojson',
                           'data': {
                               'type': 'FeatureCollection',
                               'features': []
                           }
                       }
               }

               this.layersDuo[locationCategory]['data']['features'].push(
                   {
                       'type': 'Feature',
                       'properties': {
                           'title': item.title,
                           'description': item.description,
                           'slug': item.slug,
                           'location_type': item.location_type,
                           'campus': item.campus,
                           'building_type': item.building_type,
                           'parking_type': item.parking_type
                       },
                       'geometry': {
                           'type': 'Point',
                           'coordinates': coords
                       }
                   }
               );
       });
       }
   },
   created() {
    this.fetchMapData();


      this.campusPositions = {
               'clinton-crossings': {
                   name: "Clinton Crossings",
                   location:[-77.59657907788339, 43.11329148042676]
               },
               'eastman': {
                   name: "Eastman Campus",
                   location:[-77.60077754831865, 43.1579110275134]
               },
               'highland-hospital': {
                   name: "Highland Hospital",
                   location:[-77.60650949563711, 43.13600064728628]
               },
               'medical-center': {
                   name: "Medical Center",
                   location:[-77.62406187011912, 43.1218360141324]
               },
               'middle-campus': {
                   name: "Middle Campus",
                   location:[-77.63257439616989, 43.11895344591252]
               },
               'mt-hope': {
                   name: "Mt. Hope Campus",
                   location:[-77.61377037688571, 43.13777811131888]
               },
               'river-campus': {
                   name: "River Campus",
                   location:[-77.62939781782606, 43.128430617093166]
               },
               'south-campus': {
                   name: "South Campus",
                   location:[-77.63100714331031, 43.113128584358705]
               }
           };
   },
   mounted() {
       // this.createMap();
   },
   methods: {
       async fetchMapData() {
           try {
               const res = await fetch('https://directus.its.rochester.edu/maps/items/locations');

               if (!res.ok) {
               const message = `An error has occured: ${res.status} - ${res.statusText}`;
               throw new Error(message);
               }

               this.locData = await res.json();

               this.locData.data.forEach((item) => {

               var coords = [];

               if (item.input_lat_long_directly == true) {
                   coords = [item.longitude, item.latitude];
               } else {
                   coords = [item.coords.coordinates[0], item.coords.coordinates[1]];
               }

               var locationCategory;

               if (item.location_type === 'building') {
                   locationCategory = item.building_type;
               } else {
                   locationCategory = item.parking_type;
               }

               // If the location category does not yet exist as a layer category
               if (!this.layersDuo[locationCategory])
               {
                   // create a key with the name of the layer
                   this.layersDuo[locationCategory] = 
                       {
                           'type': 'geojson',
                           'data': {
                               'type': 'FeatureCollection',
                               'features': []
                           }
                       }
               }

               this.layersDuo[locationCategory]['data']['features'].push(
                   {
                       'type': 'Feature',
                       'properties': {
                           'title': item.title,
                           'description': item.description,
                           'slug': item.slug,
                           'location_type': item.location_type,
                           'campus': item.campus,
                           'building_type': item.building_type,
                           'parking_type': item.parking_type
                       },
                       'geometry': {
                           'type': 'Point',
                           'coordinates': coords
                       }
                   }
               );
               });

               this.createMap();

           
           } catch (err) {
                console.log(err.message);
           }

       },
       toggleMobileMenu() {
           this.mobileMenuActive = !this.mobileMenuActive;
       },
       displayLocationDetails(slug) {
           const location = this.locData.data.find(e => e.slug == slug);
           const title = location.title;
           const desc = location.description;
           const img = location.image;
           var coords = null;
           const layer = (location.building_type) ? location.building_type : location.parking_type;
           this.activeLayer.id = layer;
           this.activeLayer.title = this.uiLayers[layer].title;

           if (location.input_lat_long_directly) {
               coords = {
                   type: "point",
                   coordinates: [location.longitude, location.latitude]
               }
           } else {
               coords = location.coords;
           }

           this.activeLocation = {
               'title': title,
               'desc': desc,
               'coords': coords,
               'img_url': img
           }

           //show active marker
           const cssClassNameLayer = "marker--" + this.activeLayer.id;
           const el = document.createElement('div');
           el.classList.add('marker', cssClassNameLayer);
           const marker = new mapboxgl.Marker(el).setLngLat(coords.coordinates).addTo(this.map);

           this.activeMarker.push(marker);

           this.hideAllLayers();

       },
       flyTo(location) {
           // "Fly to" the position, a latitude and longitude array
           this.map.flyTo({
               center: location,
               essential: true
           })
       },
       pushLocationRoute(slug) {
           router.push({ path: slug });
       },
       displayNavHomeView() {
           //This will "de-activate" the layer selection which triggers the home view
           this.activeLayer.id = '';
           this.activeLayer.title = '';

           //This will "de-cativate" any active locations
           this.activeLocation.title = '';
           this.activeLocation.desc = '';
           this.activeLocation.img_url = '';

           //update URL to be home
           router.push({path: "/"});

           this.displayAllLayers();

           //removeActiveMarker
           this.activeMarker.forEach(item => {
               item.remove();
           })
           

       },
       adjustCamPos(locationKey) {
           // TODO: change name

           // Reset mobile menu
           this.mobileMenuActive = false;

           // Reset campusSelectionActive
           this.campusSelectionActive = false;

           // Change btn text to campus name slected
           this.campusBtnText = this.campusPositions[locationKey].name;
           
           // "Fly to" the position, a latitude and longitude array
           this.flyTo(this.campusPositions[locationKey].location);
       },
       switchCampusSelectionActive() {
           this.campusSelectionActive = !this.campusSelectionActive;
       },
       createMap() {
           // Initialize Map Instance
           this.map = new mapboxgl.Map({
               container: 'map', // container ID
               style: 'mapbox://styles/universityrochester/ckr4z3zs50xpd17p2vkzijvpx', // style URL
               center: [-77.630, 43.128004], // starting position [lng, lat]
               zoom: 15.48 // starting zoom
               // Add zoom and rotation controls to the map.
           });

           // Load the locations
           this.map.on('load', () => {
               this.loadMapStuff();
               
               // If starting out with a URL to a location, display that location.
               if (this.$route.params.slug) {
                   this.displayLocationDetails(this.$route.params.slug);
               }
           })


       },
       activateCampusOption(option) {
           this.campusOption = option;
       },
       activateLayer(layerID) {
           //Store which layer is active so other methods can access
           this.activeLayer.id = layerID;
           this.activeLayer.title = this.uiLayers[layerID].title;

           this.hideNonActiveLayers();
       },
       hideNonActiveLayers() {
           for (const property in this.layersDuo) {
               // a property corresponds with the layer name
               if (property == this.activeLayer.id) {
                   this.map.setLayoutProperty(property, 'visibility', 'visible');
               } else {
                   this.map.setLayoutProperty(property, 'visibility', 'none');
               }
           }
       },
       hideAllLayers() {
           for (const property in this.layersDuo) {
               this.map.setLayoutProperty(property, 'visibility', 'none');
           }
       },
       displayAllLayers() {
           for (const property in this.layersDuo) {
               // a property corresponds with the layer name
               this.map.setLayoutProperty(property, 'visibility', 'visible');
           }
       },
       loadMapStuff() {

           for (const property in this.markers) {
               this.map.loadImage(this.markers[property].url, (error, image) => {
                   if (error) throw error;

                   this.map.addImage(property, image); // Add icon image to be used as location markers

                   // Add source for MapBox
                   this.map.addSource(property, this.layersDuo[property]);

                   // Add layer for Mapbox
                   this.map.addLayer({
                       'id': property,
                       'type': 'symbol',
                       'source': property, // reference the data source
                       'layout': {
                           'icon-image': property, // reference the image
                           'icon-size': .5,
                           'visibility': 'visible'
                       }
                   });

                   this.map.on('click', property, (e) => {
                       const slug = encodeURI(e.features[0].properties.slug);
                       router.push({
                           path: slug
                       });
                   });

                   // Change the cursor to a pointer when the mouse is over any layer specified 
                   this.map.on('mouseenter', property, () => {
                           this.map.getCanvas().style.cursor = 'pointer';
                   });

                   // Change it back to a pointer when it leaves.
                   this.map.on('mouseleave', property, () => {
                       this.map.getCanvas().style.cursor = '';
                   });
               });
           }

           // If a layer is active then hide all other layers
           if (this.activeLayer.id) {
               this.hideNonActiveLayers();
           }

             
       }
   }
}
</script>
<style>
   /* import proxima nova font */
   @import "https://use.typekit.net/pvj6bhs.css"; 
</style>


<style src='mapbox-gl/dist/mapbox-gl.css'>
   /* mapbox styles */
</style>

<style lang="scss">
@import '../scss/mixins.scss';
@import '../scss/colors.scss';

html {
 box-sizing: border-box;
}

*, *:before, *:after {
 box-sizing: inherit;
}

html, body, #app {
   width: 100%;
   height: 100%;
   margin: 0;
   position: relative;
}

.noselect {
 -webkit-touch-callout: none; /* iOS Safari */
   -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
       -ms-user-select: none; /* Internet Explorer/Edge */
           user-select: none; /* Non-prefixed version, currently
                                 supported by Chrome, Edge, Opera and Firefox */
}

#app {
   font-family: proxima-nova;
   overflow: hidden;
}

#map {
   width: 100%;
   height: 100%;
}

#navigation {
   width:100%;
   z-index: 99;
   position: absolute;
   background-color: $white;
   border-bottom-left-radius: 2px;
   border-bottom-right-radius: 2px;
   left: 0;
   right: 0;
   margin-top: -133px;
   transition: max-height 2s ease;

   @include mq('sm') {    
       width:300px;
       top: 120px;
       left:20px;
       margin-top: 0;
       box-shadow: 0px 0px 6px -1px $twentyfivepercent_black;
  }
}

#navigation.active {
   bottom: 0;
   transition: max-height 2s ease;

   @include mq('md') {    
       transition: none;
       bottom: auto;
  }
}

.toggle-mobile-nav {
   display: block;
   height: 25px;
   width: 28px;
   position: absolute;
   top: 15px; right: 15px;
   cursor: pointer;
   background-color: white;
   -webkit-mask-image: url("/public/ui/arrow-up-short-wide-solid.svg");
   mask-image: url("/public/ui/arrow-up-short-wide-solid.svg");
   mask-size: cover;

   @include mq('sm') {    
       display:none;
  }

  #navigation.active & {
       mask-image: url("/public/ui/arrow-down-short-wide-solid.svg");
  }
}

.topLevelText {
   display: inline-block;
   color: $interactive-blue;
}

.navigation-content__options .active .topLevelText {
   color: $white;
}

.topLevelTextBtnContainer {
   display: inline-block;

   .active & {
       color: $white;
   }
}

.topLevelIcon {
   mask-size: contain;
   mask-repeat: no-repeat;
   width: 16px;
   height: 16px;
   margin-top: 7px;
   margin-right: 5px;
   float: left;
   background-color:$interactive-blue;

   &.topLevelIcon--buildings {
       mask-image: url("/public/ui/icons/building-columns.svg");
   }

   &.topLevelIcon--parking {
       mask-image: url("/public/ui/icons/circle-parking.svg");
   }

   .navigation-content__options__button.active & {
       background-color: white;
   }

}


.icon {
   mask-size: contain;
   mask-repeat: no-repeat;
   width: 20px;
   height: 20px;
   margin-top: 12px;
   margin-right: 12px;
   float: left;
   background-color:$interactive-blue;

   &.icon--cars {
        mask-image: url("/public/ui/icons/cars.svg");
   }

   &.icon--accessible {
       mask-image: url("/public/ui/icons/accessible-icon-brands.svg");
   }

   &.icon--garage {
       mask-image: url("/public/ui/icons/garage-car.svg");
   }

   &.icon--sq-parking {
       mask-image: url("/public/ui/icons/square-parking.svg");
   }

   &.icon--reserved {
       mask-image: url("/public/ui/icons/reserved.svg");
   }

   &.icon--hat {
       mask-image: url("/public/ui/icons/graduation-cap.svg");
   }

   &.icon--people {
       mask-image: url("/public/ui/icons/users.svg");
   }

   &.icon--ball {
       mask-image: url("/public/ui/icons/tennis-ball.svg");
   }

   &.icon--hospital {
       mask-image: url("/public/ui/icons/hospital.svg");
   }

   &.icon--house {
       mask-image: url("/public/ui/icons/house-chimney-window.svg");
   }

   &.icon--cutlery {
       mask-image: url("/public/ui/icons/fork-knife.svg");
   }

   &.icon--drama {
       mask-image: url("/public/ui/icons/masks-theater.svg");
   }
}

.campus-btn, .layer-btn {
   display: inline-block;
   padding: 7px;
   margin-top: 8px;
}

.campus-btn {
   cursor: pointer;
}

.campus-btn__caret--down, .campus-btn__caret--up {
   display: inline-block;
   margin-left: 5px;
   width: 12px;
   height: 7.5px;
   background-size: cover;
}

.campus-btn__caret--down {
   background-image: url("/public/ui/down-caret.png");
}

.campus-btn__caret--up {
   background-image: url("/public/ui/up-caret.png");
}

.layer-btn__arrow {
   display: inline-block;
   position: absolute;
   left: 10px;
   top: 20px;
   width: 13px;
   height: 13px;
   cursor: pointer;
   background-image: url("/public/ui/arrow-left.png");
   background-size: cover;
}

.navigation-header {
   width: 100%;
   height: 50px;
   background-color: $rochester_blue;
   color: $white;
   border-top-left-radius: 2px;
   border-top-right-radius: 2px;
   text-align:center;
   font-size: 14px;
}

.navigation-content {
   border-top: 3px solid $interactive_blue;
   padding: 10px;
}

.navigation-content__options {
   background-color: $white;
   width: 100%;
}

.navigation-content__options__button {
   width: 50%;
   display:inline-block;
   height: 32px;
   line-height: 32px;
   text-align:center;
   font-size: 13px;
   font-weight: bold;
   border-top: 1px solid $interactive-blue;
   border-bottom: 1px solid $interactive-blue;
   cursor: pointer;
   position: relative;

   &.active {
       background-color: $interactive-blue;
       color: $white;
   }
}

.navigation-content__options__button--left {
   border-top-left-radius: 4px;
   border-bottom-left-radius: 4px;
   border-left: 1px solid $interactive-blue;
}

.navigation-content__options__button--right {
   border-top-right-radius: 4px;
   border-bottom-right-radius: 4px;
   border-right: 1px solid $interactive-blue;
}

.campus_category {
   line-height: 32px;
   border-bottom: 1px solid $gray;
   line-height: 44px;
   padding-left: 10px;
   font-weight: bold;
   font-size: 14px;
   cursor: pointer;

   &:last-child {
       border-bottom: 0;
   }
}

.campus_category-item {
   font-weight:bold;
   font-size: .9em;
   border-bottom: 1px solid $gray;
   padding: 7px 0;
   cursor: pointer;
}

.marker {
   background-size: contain;
   background-repeat: no-repeat;
   width: 44px;
   height: 57px;

   &.marker--administration {
        background-image: url("/public/pins/building/administration.png");
   }

   &.marker--academic-center {
        background-image: url("/public/pins/building/academic-center.png");
   }

   &.marker--athletic-center {
        background-image: url("/public/pins/building/sports.png");
   }

   &.marker--dining {
        background-image: url("/public/pins/building/dining.png");
   }

   &.marker--event-space {
        background-image: url("/public/pins/building/event-space.png");
   }

   &.marker--medical-facility {
        background-image: url("/public/pins/building/medical.png");
   }

   &.marker--visitor {
        background-image: url("/public/pins/parking/visitor.png");
   }

   &.marker--residence-hall {
        background-image: url("/public/pins/building/residence.png");
   }

   &.marker--general {
        background-image: url("/public/pins/parking/general.png");
   }

   &.marker--reserved {
        background-image: url("/public/pins/parking/reserved.png");
   }
}

.list-of-locations-container {
   max-height: 500px; 
   overflow-y: auto;
}

</style>